import { useRouteLoaderData } from 'react-router-dom';
import { ApiHandbook } from '../types/policy-handbook';
import { parseHandbookFromApi } from '../utils/handbook';

export const useHandbook = () => {
  const handbook = useRouteLoaderData('employee-handbook') as ApiHandbook;
  return parseHandbookFromApi(handbook);
};
